$(document).ready(function () {
    /** Period Tracker **/
    function formatString(str, ...args) {
        return str.replace(/{(\d+)}/g, (match, index) => args[index]);
    }

    // Empty arrays used to hold  the dates
    var periodDays = [];
    var prePeriodDays = [];
    var peakOvulationDays = [];
    var postPeriodDays = [];

    $('#calsection').hide();

    // Global variable for smartphone detection switch. Any smartphone/desktop specific functionlity should be based on only this variable.
    // Note : User agent in conjuction with screen horizontal resolution is used to set this flag.
    let isMobileLayout = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() < 767) {
        isMobileLayout = true;
    }
    if ($(window).width() < 1023) {
        isMobileLayout = true;
    }

    const locale = $('#datepicker').data('locale');
    const dayInitials = $.datepicker.regional[locale]?.dayNamesMin.map(d => d.charAt(0));

    if (locale === 'fr') {
        $.datepicker.setDefaults($.datepicker.regional['fr']);
    } else {
        $.datepicker.setDefaults($.datepicker.regional['']);
    }

    // Method supplied by the plugin Jquery.UI.Custom.js is used for creating calendar and appending to the selector.
    // It is highly recommended that you go througt the api documentation at http://api.jqueryui.com/datepicker/ before modifying any methods.
    $('div#datepicker').datepicker({
        dayNamesMin: dayInitials,
        showOtherMonths: true,
        selectOtherMonths: false,
        onSelect: function (dateText, inst) {
            const date = $(this).datepicker('getDate');

            const day = date.getDate();
            const month = $.datepicker.formatDate('M', date);

            let suffix = '';
            let htmlString = '';

            if (locale === 'en') {
                switch (day) {
                    case 1: case 21: case 31: suffix = 'st'; break;
                    case 2: case 22: suffix = 'nd'; break;
                    case 3: case 23: suffix = 'rd'; break;
                    default: suffix = 'th';
                }

                htmlString = `<span>${month}. ${day}${suffix}</span>`;
            } else {
                htmlString = `<span>${day} ${month}</span>`;
            }

            $('#todaydate').html(htmlString);
            $('div#datepicker').hide();
        },
    });

    // To set the current date by default, click action is triggered.
    // It is equivalent to navigating to the current day in the calendar and clicking on it.
    $('.ui-datepicker-today').click();

    $('#selectdate').click(function (event) {
        event.stopPropagation();
        $('div#datepicker').toggle();
    });

    $('html').on('click', function () {
        $('div#datepicker').hide();
        $('.fa-calendar').removeClass('icon_active');
    });

    $('a.date-picker,div#datepicker').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
    });

    $('.tracknow').click(function () {
        var monthCount = isMobileLayout ? 1 : 3;

        var selectedDate = $('div#datepicker').datepicker('getDate');
        var cycleLength = parseInt($('#cycleLen').text(), 10);
        var duration = parseInt($('#duration').text(), 10);

        RenderCalendar(selectedDate, cycleLength, duration, monthCount);
        $('html, body').animate({ scrollTop: $('#calsection').offset().top }, 1000);
    });

    $('.nextPrevious .previous_result').click(function () {
        var monthCount = isMobileLayout ? -1 : -3;
        ExtendCalendar(monthCount);
    });

    $('.nextPrevious .next_result').click(function () {
        var monthCount = isMobileLayout ? 1 : 3;
        ExtendCalendar(monthCount);
    });

    $('#printit, #pdfit ').on('click', function (event) {
        window.print();
    });

    function RenderCalendar(date, length, duration, monthCount) {
        var cycle = 0;
        var singleDay = 60 * 60 * 24 * 1000; // Total number of milliseconds in a day.

        var monthFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastMonth = new Date(date.getFullYear(), date.getMonth() + monthCount, 2);
        var nextCycleStartDate = date;
        var cycleStart = date;

        periodDays = [];
        prePeriodDays = [];
        postPeriodDays = [];
        peakOvulationDays = [];

        // Start the cycle from One month before the visible month
        while (monthFirstDay < cycleStart) {
            cycleStart = new Date(cycleStart - length * singleDay);
        }

        while (nextCycleStartDate < lastMonth) {
            var startDate = Date.parse(cycleStart);
            nextCycleStartDate = new Date(startDate + length * singleDay);

            // Pre-Period Days
            for (var i = 1; i <= 2; i++) {
                var tempDate = startDate - i * singleDay;
                prePeriodDays.push(new Date(tempDate).toDateString());
            }

            // Period Days
            for (var i = 0; i < duration; i++) {
                var tempDate = startDate + i * singleDay;
                periodDays.push(new Date(tempDate).toDateString());
            }

            // Post-Period Days
            for (var i = 0; i < 2; i++) {
                var tempDate = startDate + (duration + i) * singleDay;
                postPeriodDays.push(new Date(tempDate).toDateString());
            }

            // Peak-Ovulation Days
            for (var i = 0; i < 5; i++) {
                var tempDate = startDate + (10 + i) * singleDay;
                peakOvulationDays.push(new Date(tempDate).toDateString());
            }

            cycleStart = nextCycleStartDate;
        }

        for (var i = 0; i < duration * 2; i++) {
            if (i == duration) {
                var startdate = new Date(periodDays[i]);
            }
            if (i == duration * 2 - 1) {
                var enddate = new Date(periodDays[i]);
            }
        }
        $('.pc-add-to-cal').empty();
        addtocal(startdate, enddate);
        CreateCalendar(date, monthCount);
    }

    function ExtendCalendar(monthCount) {
        /// <summary>
        ///     Changes the month displayed in the calendar.
        ///     Used for navigating visible months in the displayed tracker
        /// </summary>
        /// <param name="monthCount" type="int">
        ///     Number of months to be rendered.
        /// </param>

        var selectedDate = $('div#datepicker').datepicker('getDate');
        var cycleLength = parseInt($('#cycleLen').text(), 10);
        var duration = parseInt($('#duration').text(), 10);

        var singleDay = 60 * 60 * 24 * 1000;
        var lastMonth = new Date();
        var nextCycle = selectedDate;

        // monthCount will be -ve for previous months w.r.t the months displayed
        // monthCount will be +ve for upcoming months w.r.t the months displayed
        if (monthCount > 0) {
            lastMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + monthCount, 2);
            while (lastMonth > nextCycle) {
                nextCycle = new Date(Date.parse(nextCycle) + cycleLength * singleDay);
            }
        } else {
            lastMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + monthCount + 1, 0);
            while (lastMonth <= nextCycle) {
                nextCycle = new Date(Date.parse(nextCycle) - cycleLength * singleDay);
            }
            monthCount = -monthCount;
        }

        // Since the RenderCalendar method always takes the start date from datepicker plugin,
        // the next cycle start date should be set before calling up the method
        $('div#datepicker').datepicker('setDate', nextCycle);
        RenderCalendar(nextCycle, cycleLength, duration, monthCount);
    }

    function CreateCalendar(initialDate, monthCount) {
        /// <summary>
        ///     Creates a calendar by invoking the datepicker method of the plugin.
        ///     The created calendar is always appended to the hardcoded jQuery selector
        /// </summary>
        /// <param name="monthCount" type="int">
        ///     Number of months to be rendered.
        /// </param>

        // Go through the api documentation.
        // Following methods should not be modified unless the user has thorough knowledge of the datepicker plugin

        $('#period_result_calendar').datepicker('destroy');

        $('#period_result_calendar').datepicker({
            dayNamesMin: dayInitials,
            numberOfMonths: monthCount,
            beforeShowDay: PaintCalendar,
            showOtherMonths: true,
            selectOtherMonths: false,
            defaultDate: initialDate,
        });

        // Smartphone does not have clearly labeled button for navigation.
        // So the default nav buttons supplied by the datepicker is reused.
        if (isMobileLayout) {
            $('#period_result_calendar .ui-corner-all').off('click');
            $('#period_result_calendar .ui-datepicker-prev').on('click', function () {
                $('.previous_result').click();
            });
            $('#period_result_calendar .ui-datepicker-next').on('click', function () {
                $('.next_result').click();
            });
        } else {
            $('#period_result_calendar .ui-datepicker-prev').on('click', function () {
                $('.previous_result').click();
            });
            $('#period_result_calendar .ui-datepicker-next').on('click', function () {
                $('.next_result').click();
            });
        }

        // Auto generated classes interrupt the functionality
        $('#period_result_calendar .ui-datepicker-today').removeClass('ui-datepicker-today');
        $('#period_result_calendar .ui-datepicker-current-day').removeClass('ui-datepicker-current-day');

        $('.period_legends').show();
        $('#calsection').show();
        $('.period_details div').hide();

        var eventType = '';

        if (isMobileLayout) {
            eventType = 'click';
        } else {
            eventType = 'mouseover click';
            $('.periodDays_detail').show();
        }

        // Events bound for displaying tips for the selected phase or day
        $('.period_results a').on(eventType, function (event) {
            event.preventDefault();
            event.stopPropagation();
            var detail = $('.' + $(this).parent().attr('class').split(' ').pop() + '_detail');

            if (detail.length) {
                if (!isMobileLayout) {
                    // fix for scroll movement in Windows Safari
                    $('.period_details').css('height', $(detail).css('height'));
                    $('.period_details').css('margin-top', $(detail).css('margin-top'));
                }
                $('.period_details div').hide();
                $(detail).show();
            }
        });
    }

    function PaintCalendar(date) {
        /// <summary>
        ///     This function will be called by the datepicker on
        ///     creation of each day for adding attributes to days.
        ///     Should not be called directly by the user.
        /// </summary>
        /// <param name="date" type="DateTime">
        ///     Then date object will be passed by the datepicker plugin.
        /// </param>

        var dateValue = date.toDateString();

        if ($.inArray(dateValue, periodDays) > -1) {
            return [true, 'period-days', 'Heaviest Flow'];
        } else if ($.inArray(dateValue, prePeriodDays) > -1) {
            return [true, 'pre-period', 'Pre-Period'];
        } else if ($.inArray(dateValue, postPeriodDays) > -1) {
            return [true, 'post-period', 'Post Period'];
        } else if ($.inArray(dateValue, peakOvulationDays) > -1) {
            return [true, 'peak-ovulation', 'Peak Ovulation'];
        } else {
            return [true, ''];
        }
    }

    function addtocal(startdate, enddate) {
        var myCalendar = createCalendar({
            options: {
                class: '',

                // You can pass an ID. If you don't, one will be generated for you
                id: '',
            },
            data: {
                // Event title
                title: 'Period Days',

                // Event start date
                start: new Date(startdate),

                // Event duration (IN MINUTES)
                duration: 120,

                // You can also choose to set an end time
                // If an end time is set, this will take precedence over duration
                end: new Date(enddate),

                // Event Address
                address: '',

                // Event Description
                description: 'Period Days',
            },
        });

        document.querySelector('.pc-add-to-cal').appendChild(myCalendar);
    }

    /** Date Picker **/
    $('#dt').datepicker({
        dateFormat: 'M. d',
    });

    //Get the current date in a dateobject
    var currentDate = new Date();
    //Offset the current date by how many days you need
    currentDate.setDate(currentDate.getDate() + 1);
    //Insert placeholder date

    $('#dt').datepicker('setDate', currentDate);

    // days
    $('.pc-days-plus').click(function () {
        let num = parseInt($('.pc-period-lasted').text());
        if (num > 9) {
            //do nothing
        } else {
            $('.pc-period-lasted').text(num + 1);
        }
    });

    $('.pc-days-minus').click(function () {
        let num = parseInt($('.pc-period-lasted').text());
        if (num < 2) {
            //do nothing
        } else {
            $('.pc-period-lasted').text(num - 1);
        }
    });

    // cycle
    $('.pc-cycle-plus').click(function () {
        let num = parseInt($('.pc-cycle-lasted').text());
        if (num > 44) {
            //do nothing
        } else {
            $('.pc-cycle-lasted').text(num + 1);
        }
    });

    $('.pc-cycle-minus').click(function () {
        let num = parseInt($('.pc-cycle-lasted').text());
        if (num < 12) {
            //do nothing
        } else {
            $('.pc-cycle-lasted').text(num - 1);
        }
    });

    //inline cals
    $('#cal-ct').datepicker({
        numberOfMonths: 3,
        showCurrentAtPos: 1,
        dayNamesMin: dayInitials,
    });

    /** OuiCal **/
    const MS_IN_MINUTES = 60 * 1000;

    function formatTime (date) {
        return date.toISOString().replace(/-|:|\.\d+/g, '');
    };

    function calculateEndTime (event) {
        return event.end ? formatTime(event.end) : formatTime(new Date(event.start.getTime() + event.duration * MS_IN_MINUTES));
    };

    const calendarGenerators = {
        google: function (event) {
            const startTime = formatTime(event.start);
            const endTime = calculateEndTime(event);

            const href = encodeURI(
                [
                    'https://www.google.com/calendar/render',
                    '?action=TEMPLATE',
                    '&text=' + (event.title || ''),
                    '&dates=' + (startTime || ''),
                    '/' + (endTime || ''),
                    '&details=' + (event.description || ''),
                    '&location=' + (event.address || ''),
                    '&sprop=&sprop=name:',
                ].join('')
            );
            return '<a class="igoogle" target="_blank" href="' + href + '"> Google Calendar</a>';
        },

        yahoo: function (event) {
            const eventDuration = event.end ? (event.end.getTime() - event.start.getTime()) / MS_IN_MINUTES : event.duration;

            // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
            const yahooHourDuration = eventDuration < 600 ? '0' + Math.floor(eventDuration / 60) : Math.floor(eventDuration / 60) + '';

            const yahooMinuteDuration = eventDuration % 60 < 10 ? '0' + (eventDuration % 60) : (eventDuration % 60) + '';

            const yahooEventDuration = yahooHourDuration + yahooMinuteDuration;

            // Remove timezone from event time
            const st = formatTime(new Date(event.start - event.start.getTimezoneOffset() * MS_IN_MINUTES)) || '';

            const href = encodeURI(
                [
                    'http://calendar.yahoo.com/?v=60&view=d&type=20',
                    '&title=' + (event.title || ''),
                    '&st=' + st,
                    '&dur=' + (yahooEventDuration || ''),
                    '&desc=' + (event.description || ''),
                    '&in_loc=' + (event.address || ''),
                ].join('')
            );

            return '<a class="iyahoo" target="_blank" href="' + href + '"> Yahoo! Calendar</a>';
        },

        ics: function (event, eClass, calendarName) {
            const startTime = formatTime(event.start);
            const endTime = calculateEndTime(event);

            const href = encodeURI(
                'data:text/calendar;charset=utf8,' +
                    [
                        'BEGIN:VCALENDAR',
                        'VERSION:2.0',
                        'BEGIN:VEVENT',
                        'URL:' + document.URL,
                        'DTSTART:' + (startTime || ''),
                        'DTEND:' + (endTime || ''),
                        'SUMMARY:' + (event.title || ''),
                        'DESCRIPTION:' + (event.description || ''),
                        'LOCATION:' + (event.address || ''),
                        'END:VEVENT',
                        'END:VCALENDAR',
                    ].join('\n')
            );

            return '<a class="' + eClass + '" target="_blank" href="' + href + '"> ' + calendarName + ' Calendar</a>';
        },

        ical: function (event) {
            return this.ics(event, 'ical', 'iCal');
        },

        outlook: function (event) {
            return this.ics(event, 'ical', 'Outlook');
        },
    };

    function generateCalendars (event) {
        return {
            google: calendarGenerators.google(event),
            yahoo: calendarGenerators.yahoo(event),
            ical: calendarGenerators.ical(event),
            outlook: calendarGenerators.outlook(event),
        };
    };

    // Make sure we have the necessary event data, such as start time and event duration
    function validParams (params) {
        return params.data !== undefined && params.data.start !== undefined && (params.data.end !== undefined || params.data.duration !== undefined);
    };

    function generateMarkup (calendars, clazz, calendarId) {
        const addToCalendarText = $('.pc-add-to-cal').data('text');
        const result = document.createElement('div');
        result.innerHTML = '<label for="checkbox-for-' + calendarId + '" class="add-to-calendar-checkbox"> ' + addToCalendarText + '</label>';
        result.innerHTML += '<input name="add-to-calendar-checkbox" class="add-to-calendar-checkbox" id="checkbox-for-' + calendarId + '" type="checkbox">';

        Object.keys(calendars).forEach(function (services) {
            result.innerHTML += calendars[services];
        });

        result.className = 'add-to-calendar';
        if (clazz !== undefined) {
            result.className += ' ' + clazz;
        }

        result.id = calendarId;
        return result;
    };

    function getClass (params) {
        if (params.options && params.options.class) {
            return params.options.class;
        }
    };

    function getOrGenerateCalendarId (params) {
        return params.options && params.options.id ? params.options.id : Math.floor(Math.random() * 1000000); // Generate a 6-digit random ID
    };

    function createCalendar(params) {
        if (!validParams(params)) {
            console.log('Event details missing.');
            return;
        }

        return generateMarkup(generateCalendars(params.data), getClass(params), getOrGenerateCalendarId(params));
    }

    $('.inc-ct').addClass('visible'); // fade in after html update from formatString()
});
